import React from 'react';
import { MapPin, Award, Shield, Zap } from 'lucide-react';

const MadeInIndiaSection = () => {
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-500/5 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-3 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-5 py-3 mb-6">
              <MapPin className="w-5 h-5 text-yellow-600" />
              <span className="text-yellow-700 text-sm font-semibold tracking-wide">PROUDLY INDIAN</span>
            </div>

            <h2 className="text-4xl sm:text-5xl font-bold text-black mb-6 leading-tight">
              100% Made in <span className="text-yellow-500">India</span>
            </h2>

            <p className="text-zinc-600 text-lg leading-relaxed mb-8">
              Every RK ROTOARC product is designed, engineered, and manufactured in India. We take pride in supporting local manufacturing excellence while delivering world-class quality that meets international standards.
            </p>

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-yellow-500/10 flex items-center justify-center flex-shrink-0">
                  <Shield className="w-6 h-6 text-yellow-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1">Quality You Can Trust</h4>
                  <p className="text-zinc-600 text-sm leading-relaxed">
                    Manufactured with premium Indian materials and rigorous quality control processes
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-yellow-500/10 flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-yellow-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1">ISI Certified</h4>
                  <p className="text-zinc-600 text-sm leading-relaxed">
                    Meets Indian Standards Institution certifications for safety and performance
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-yellow-500/10 flex items-center justify-center flex-shrink-0">
                  <Zap className="w-6 h-6 text-yellow-600" />
                </div>
                <div>
                  <h4 className="font-semibold text-black mb-1">Supporting Local Industry</h4>
                  <p className="text-zinc-600 text-sm leading-relaxed">
                    Contributing to India's manufacturing ecosystem and creating local employment
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - Visual Element */}
          <div className="relative">
            <div className="relative bg-gradient-to-br from-yellow-50 to-white border border-yellow-200 rounded-2xl p-12 shadow-lg">
              {/* India Flag Colors Accent */}
              <div className="absolute top-0 left-0 right-0 h-2 rounded-t-2xl overflow-hidden flex">
                <div className="flex-1 bg-orange-500"></div>
                <div className="flex-1 bg-white"></div>
                <div className="flex-1 bg-green-600"></div>
              </div>

              {/* Central Badge */}
              <div className="flex flex-col items-center justify-center text-center py-8">
                <div className="w-32 h-32 rounded-full bg-yellow-500 flex items-center justify-center mb-6 shadow-xl">
                  <MapPin className="w-16 h-16 text-black" />
                </div>
                
                <h3 className="text-3xl font-bold text-black mb-2">
                  Made in India
                </h3>
                <p className="text-yellow-700 font-semibold text-lg mb-6">
                  Since 2015
                </p>

                <div className="grid grid-cols-3 gap-8 w-full mt-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-600 mb-1">100%</div>
                    <div className="text-zinc-600 text-xs font-medium">Indian Made</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-600 mb-1">ISI</div>
                    <div className="text-zinc-600 text-xs font-medium">Certified</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-yellow-600 mb-1">10+</div>
                    <div className="text-zinc-600 text-xs font-medium">Years Trust</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-yellow-500/20 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MadeInIndiaSection;
